import {
  Component,
  ViewChild,
  TemplateRef,
  Inject,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { faSpinner } from "@fortawesome/pro-light-svg-icons";
import {
  faTimes,
  faCheck,
  faTimesCircle,
  faInfoCircle,
  faTable as fasTable,
  faFileExcel as fasFileExcel,
  faChartLine as fasChartLine,
  faArrowToBottom as fasArrowToBottom,
} from "@fortawesome/pro-solid-svg-icons";
import { Store } from "@ngrx/store";
import { Subscription, combineLatest } from "rxjs";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";
import {
  PeriodState,
  PeriodUserSettingObj,
  convertPeriodMetaToUserSettings,
  isBasisFullYear,
  getSelectedBasisOptionId,
  getSelectedPeriodBasis,
} from "@va/core-library/period-filter";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { Dictionary } from "src/app/store/models/common_types";
import { DOCUMENT } from "@angular/common";
import { AppService } from "src/app/app.service";
import { environment } from "../../../environments/environment";
import { getSelectedMarketIdFromList } from "src/app/comps-page/utils";
import { CompsDataService } from "src/app/comps-page/comps-data.service";
import { CompTypes, CompsTable } from "src/app/comps-page/comps-page.model";
import Highcharts from "highcharts";
import {
  getSelectedPeriods,
  convertRelativePeriodIdToLabel,
  getPeriodTypeDataId,
} from "src/app/utils/period-utils";
import {
  MARKET_DATA_LIST,
  GROWTH_OPTIONS,
  REVISION_OPTIONS,
  MARKETDATA_COPYRIGHT_MESSAGE,
} from "src/app/common-constants";
import {
  VAIconRegistryService,
  chevronDown,
  chevronUp,
  infoCircle,
} from "@va/core-library/icons";
import { ComparativeAnalysisService } from "./../comparative-analysis.service";
import { SetComparativeHeaderTitle } from "src/app/store/actions/comparative-analysis.actions";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { LineItemModalComponent } from "src/app/shared/line-item-modal/line-item-modal.component";
import { ComparativeTickerModalComponent } from "../comparative-ticker-modal/comparative-ticker-modal.component";
import { AddWatchlistData } from "src/app/store/actions/global.actions";
import { WatchlistService } from "src/app/watchlist/watchlist.service";
import { TAB_BE_MAPPING } from "../constants";
import {
  updateCustomTableSettings,
  updateCustomTableSettingsForTickers,
} from "../comparative-analysis-utils";

@Component({
  selector: "app-comparative-comparision",
  templateUrl: "./comparative-comparision.component.html",
  styleUrls: ["./comparative-comparision.component.scss"],
})
export class ComparativeComparisionComponent {
  @Input() isActive = true;
  @Input() state;
  @Output() updateCompState: EventEmitter<any> = new EventEmitter();
  @Output() updateGridSortByColumnId: EventEmitter<any> = new EventEmitter();
  @Input() shouldFetchData = false;
  @Output() onDataFetchInitiate: EventEmitter<any> = new EventEmitter();
  @Input() recentlyVisitedCompanies;
  @Input() watchlistData;
  @Input() industryMenuData;
  @Input() suggestedPeers;
  @Input() tickerModalDataReady;
  @Input() marketGeoData;
  @Input() lineItemsData;
  @Input() isStdLineItemsUpdateInProgress = false;
  @Input() sortByColumnId;
  @Output() onFetchLineitemData: EventEmitter<any> = new EventEmitter();
  @Output() initiateWatchlistFetch: EventEmitter<any> = new EventEmitter();
  @Output() updateTrendStateWithoutMakingDataCalls: EventEmitter<any> =
    new EventEmitter();
  @Output() updateUnsavedDataStatus: EventEmitter<any> = new EventEmitter();

  //icons
  faTimes = faTimes;
  faCheck = faCheck;
  faTimesCircle = faTimesCircle;
  faInfoCircle = faInfoCircle;
  faSpinner = faSpinner;
  fasTable = fasTable;
  fasChartLine = fasChartLine;
  fasFileExcel = fasFileExcel;
  fasArrowToBottom = fasArrowToBottom;

  //page related variables
  tabType = "Comparision";
  pageType;
  compType;
  compId;
  id;

  // filters data
  sector;
  industry;
  suggestedLineItems = [];
  tickers = [];
  lineItem = undefined;
  viewBy = ["values"];
  revision = "";
  currency = "";
  periodData: PeriodState = undefined;
  periodUserSetting: PeriodUserSettingObj = undefined;
  showBlankRows = false;
  isIndexToHundreadSelected = false;
  periodsWithAvailableData;
  sourceList;
  highlightBestMatches = false;

  //instance variables
  industryId: number;
  compsTableData: CompsTable = {
    rows: [],
    columns: [],
    columnData: {},
    rowData: {},
    filter: {},
    extras: {},
    title: "",
  };
  periodList: Array<string>;
  periodLabel: Array<string>;
  periodType;
  magnitudeMessage;
  companyCount;
  radioValueEstimates;
  dataview: any;
  lineTotalMap = {};
  selectedSector = "";
  selectedIndustry = "";
  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "default",
  };
  tsChartData: any = {};
  tsChartValObj: any = {};
  timeSeriesExportType = "TimeSeries";
  selectedChart = "industry-page-timeseries";
  lineHasTotal = false;
  radioValue = "top10";
  allTickerInfo: Dictionary<any> = {};
  magnitude = "";
  unit: string;
  currencySymbol: string;
  yearTypeFilterVisible = false;
  yearTypeApplied = false;
  yearTypePopoverOpen = false;
  downloadOptVisible = false;
  chartInstance: Highcharts.Chart;
  source = "VA Actuals/Consensus";
  calendar_year = new Date().getFullYear();
  activePeriod = `CY-${new Date().getFullYear()}`;
  tickerPeriodEstimationData = {};
  compTableClassName;
  showMLTableInitialHeight: number;
  showMLActiveStateHeight: number;
  isTableInExpandState = false;
  hasShowMoreButton = false;
  assets = environment.assetUrl;
  apiEP: string = window.apiUrl;
  marketCap = [-1];
  region = [-1];
  countries;
  subGroup = -1;
  showBlankRowsLabel = "Show Blank Rows";
  marketDataAccess;
  fetchAndCreateCompsData = 0;
  lineItemsModal: NzModalRef;
  modalTitle = "Edit Line Items";
  MAX_LINES_TIMESERIES = 20;
  marketItemsData = [].concat([...MARKET_DATA_LIST]);
  marketDataItemCopy = []; // note: this will be same as market data that we get from meta call. we are using copy so that we can reset the market items on popup cancel/close
  loadingDocuments;
  apply_yoy_format = true;
  selectedLineItemId = [];
  selectedCompsType = "Calenderized";
  tickerLimit = 500;
  tickersModal: NzModalRef;
  storeDataKey = "watchlist";
  headerTitle = "";
  periodMinMax = { min: -10, max: 9 };
  growthOptions = GROWTH_OPTIONS;
  revisionOptions = REVISION_OPTIONS;
  viewportOptions;
  showCompanyCount = true;
  collapsibleList;
  activeAccordionItemId;
  gridSortByColumnId;
  chartPopupType;
  chartPopupDataToUse;
  chartPopupVisible;
  overlayOn = false;
  sortedTickers;
  marketDataCopyRightMessage = MARKETDATA_COPYRIGHT_MESSAGE;

  //popovers
  isMegaMenuVisible = false;
  exportOptVisible = false;
  isNoTickerPopupVisible = false;

  //loader
  isMetaInProgress = false;
  isCompsDataInProgress = true;
  isChartDataInProgress = false;
  isUserSettingUpdateInProgress = false;
  isCompTableExportInProgress = false;
  totalLogicCheckInProgress = false;

  //snackbar
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  //urls
  legacyUrl = `${window.caUrl}/app`;

  //subscribers
  routeParamSubscriber: Subscription;
  sectorIndustryStoreSubscriber: Subscription;
  sectorIndustryStoreReloadSubscriber: Subscription;
  sectorIndustryStoreHasDataSubscriber: Subscription;
  sectorMetaSubscriber: Subscription;
  industryDetailsSubscriber: Subscription;
  globalAppSettingSubscriber: Subscription;
  industryMetaSubscriber: Subscription;
  compsDataSubscriber: Subscription;
  totalLineItemLogicCheckSubscriber: Subscription;
  userTabSettingsSubscriber: Subscription;
  userIndustrySettingsSubscriber: Subscription;
  lineItemsSubscriber: Subscription;
  currencyMessageSubscriber: Subscription;

  inViewportChange;

  constructor(
    private dataService: ComparativeAnalysisService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    public router: Router,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
    private compsDataService: CompsDataService,
    private modalService: NzModalService,
    private watchlistDataService: WatchlistService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {
    this.iconRegistry.registerIcons([chevronDown, chevronUp, infoCircle]);
  }

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;
  @ViewChild("warningTemplate") warningTemplate: TemplateRef<any>;

  /**
   * On initialization, it checks for industry id from routes
   * It resets filters value
   * Make call to get Industry meta and stores it
   */
  ngOnInit() {
    const urlParametrs = combineLatest(
      this.route.params,
      this.route.queryParams,
      (params, queryParams) => ({
        params,
        queryParams,
      }),
    );

    urlParametrs.subscribe((routeParams) => {
      const { params, queryParams } = routeParams;
      this.pageType = params.pageType;
      this.compType = this.pageType === "user" ? "user" : queryParams.comp_type;
      this.compId = this.id =
        this.pageType === "user" ? params.compId : undefined;
      if (this.compType === "industry") {
        this.industryId = parseInt(queryParams.id) || 166;
        this.id = parseInt(queryParams.id);
      }
      if (this.compType === "system" || this.compType === "watchlist") {
        this.id = parseInt(queryParams.id);
      }
    });

    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data) {
          //raise update of common state to trigger data calls on all tabs
          if (this.isActive && !this.isMetaInProgress) {
            this.onDataFetchInitiate.emit();
            this.setSortByColumnId();
            this.fetchAndCreateCompsData += 1;
          }
        }
      });
    this.getPeriodsWithAvailableData(this.tickers.map((item) => item.ticker));
  }

  ngOnChanges(changes) {
    if (
      changes.state &&
      changes.state.currentValue &&
      changes.state.currentValue !== changes.state.previusValue
    ) {
      this.headerTitle = this.state.headerTitle;
      this.lineItem = this.state.lineItem;
      this.marketItemsData = this.state.marketItemsData;
      this.marketDataItemCopy = getSelectedMarketIdFromList(
        this.state.marketItemsData,
      );

      this.periodList = this.state.periodList;
      this.periodUserSetting = this.state.periodUserSetting;
      this.periodType = this.state.periodType;
      this.tickers = this.state.tickers;
      this.currency = this.state.currency;
      this.viewBy = this.state.viewBy;
      this.revision = this.state.revision;
      if (this.viewBy) {
        this.dataview = {
          view_by: [...this.viewBy],
          revision: this.revision,
        };
      }
      this.periodData = this.state.periodData;
      this.periodLabel = this.state.periodLabel;
      this.magnitudeMessage = this.state.magnitudeMessage;
      this.marketDataAccess = this.state.marketDataAccess;
      this.source = this.state.source;
      this.selectedLineItemId = this.state.selectedLineItemId;
      this.periodUserSetting = this.state.periodUserSetting;
      this.sourceList = this.state.sourceList;
    }

    if (
      changes.sortByColumnId &&
      changes.sortByColumnId.currentValue !==
        changes.sortByColumnId.previousValue
    ) {
      this.gridSortByColumnId = this.sortByColumnId;
    }

    // fetch data when there is change in state and user is in current tab
    if (
      changes.shouldFetchData &&
      changes.shouldFetchData.currentValue !==
        changes.shouldFetchData.previusValue &&
      changes.shouldFetchData.currentValue
    ) {
      if (this.isActive && this.tickers && this.tickers.length) {
        this.onDataFetchInitiate.emit();

        this.collapsibleList = this.createNewCollapsibleList(
          this.periodList,
          this.periodLabel,
        );

        this.setSortByColumnId();
        this.fetchAndCreateCompsData += 1;
      }
    }

    // fetch data when there is change in state and user is swithing to the current tab from another tab
    if (
      changes.isActive &&
      !changes.isActive.firstChange &&
      changes.isActive.currentValue &&
      !changes.isActive.previousValue
    ) {
      if (this.shouldFetchData && this.tickers && this.tickers.length) {
        this.onDataFetchInitiate.emit();

        this.collapsibleList = this.createNewCollapsibleList(
          this.periodList,
          this.periodLabel,
        );

        this.setSortByColumnId();
        this.fetchAndCreateCompsData += 1;
      }
    }
  }

  /**
   * Unsubscribes from store when component is destroyed
   */
  ngOnDestroy(): void {
    if (this.routeParamSubscriber) {
      this.routeParamSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreSubscriber) {
      this.sectorIndustryStoreSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreReloadSubscriber) {
      this.sectorIndustryStoreReloadSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreHasDataSubscriber) {
      this.sectorIndustryStoreHasDataSubscriber.unsubscribe();
    }
    if (this.industryDetailsSubscriber) {
      this.industryDetailsSubscriber.unsubscribe();
    }
    if (this.globalAppSettingSubscriber) {
      this.globalAppSettingSubscriber.unsubscribe();
    }
    if (this.industryMetaSubscriber) {
      this.industryMetaSubscriber.unsubscribe();
    }
    if (this.compsDataSubscriber) {
      this.compsDataSubscriber.unsubscribe();
    }
    if (this.totalLineItemLogicCheckSubscriber) {
      this.totalLineItemLogicCheckSubscriber.unsubscribe();
    }
    if (this.userTabSettingsSubscriber) {
      this.userTabSettingsSubscriber.unsubscribe();
    }
    if (this.lineItemsSubscriber) {
      this.lineItemsSubscriber.unsubscribe();
    }
    if (this.currencyMessageSubscriber) {
      this.currencyMessageSubscriber.unsubscribe();
    }
    if (this.userIndustrySettingsSubscriber) {
      this.userIndustrySettingsSubscriber.unsubscribe();
    }
    this.dismissSnackBar();
  }

  //methods
  /**
   * It executes on industry change
   * Makes call to get Industry meta and updates the filters selection data according to it.
   * Makes call to get stdLines Info for the received tickers
   */
  fetchAndUpdateComparativeMeta(payload) {
    this.isMetaInProgress = true;
    // reset filters on change of industry
    this.setDefaultFilters();

    if (this.industryMetaSubscriber) {
      this.industryMetaSubscriber.unsubscribe();
    }
    this.industryMetaSubscriber = this.dataService
      .fetchComparativeAnalysisMeta(payload)
      .subscribe((response: { status: string; data: any }) => {
        if (response["status_code"] === 403) {
          window.location.href = `${this.legacyUrl}/home`;
        }
        if (response.status === "success") {
          const responseData = response.data;
          this.marketDataAccess = responseData.marketdata_access;
          if (!this.marketDataAccess) {
            this.snackbarInfo.message = `You are currently not entitled to view Market/Valuation data. Please reach out to your Customer Success Manager if you require access.`;
            this.snackbarInfo.type = "info";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }

          this.store.dispatch(
            new SetComparativeHeaderTitle(responseData.comps_name),
          );
          this.updateStateWithMeta(responseData);
          if (responseData.ticker_info.length === 0) {
            this.isNoTickerPopupVisible = true;
          } else if (
            !responseData.selected_lines ||
            !responseData.selected_lines.length
          ) {
            this.snackbarInfo.message = "No data Available.";
            this.snackbarInfo.type = "info";
            this.showSnackBarToastMessage(this.snackbarInfo);
          } else {
            // store meta information
            // this.updateStateWithMeta(responseData);
            const tickerIds = this.tickers.map((item) => item.ticker);
            this.getPeriodsWithAvailableData(tickerIds);
            this.onFetchLineitemData.emit({
              tickers: tickerIds,
              showSuggestedLineItems: false,
              currency: responseData.currency,
              suggestedLineItems: this.suggestedLineItems,
            });
          }
          this.isMetaInProgress = false;
        }
      });
  }

  /**
   * store meta details to variables
   *  @param {obj} meta: meta details
   */
  updateStateWithMeta(meta) {
    this.lineItem = meta.selected_lines;
    this.selectedLineItemId = meta.selected_lines.map(
      (item) => item.uniquesliid,
    );
    this.marketItemsData = meta.market_data[0];
    this.marketDataItemCopy = getSelectedMarketIdFromList(this.marketItemsData);

    this.currency = meta.currency || "USD";
    this.tickers = meta.ticker_info || [];
    this.periodData = meta.period_selector;
    const periodUserSettings = convertPeriodMetaToUserSettings(
      meta.period_selector,
    );
    this.periodUserSetting = periodUserSettings;
    this.periodList = getSelectedPeriods(
      meta.period_selector,
      false,
      false,
      true,
    );
    const periodTypeId = periodUserSettings.type;
    this.periodType = periodTypeId;

    const selectedBasisId =
      this.periodData &&
      this.periodData.period_basis &&
      this.periodData.period_basis[periodTypeId]
        ? getSelectedBasisOptionId(
            this.periodData.period_basis[periodTypeId].from_basis,
          )
        : undefined;
    const isYearlyBasisId = isBasisFullYear(selectedBasisId);
    this.periodLabel =
      periodTypeId === "rel"
        ? this.periodList.map((item) =>
            convertRelativePeriodIdToLabel(item, isYearlyBasisId),
          )
        : this.periodList;
    this.magnitudeMessage = meta.magnitude_message;
    this.viewBy = meta.data_view ? meta.data_view.view_by : undefined;
    this.revision = meta.data_view ? meta.data_view.revision : undefined;
    this.dataview = {
      view_by: [...this.viewBy],
      revision: this.revision,
    };
    this.showBlankRows = meta.show_blank_rows;
    this.source = meta.source;
    this.sourceList = meta.all_sources;

    // reset the selected line item if no tickers available
    if (this.lineItem && (!meta.ticker_info || !meta.ticker_info.length)) {
      this.lineItem = undefined;
    }
  }

  setSortByColumnId() {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.gridSortByColumnId = "";
    } else if (this.gridSortByColumnId !== "") {
      this.gridSortByColumnId = this.selectedLineItemId
        ? this.selectedLineItemId[0].toString()
        : undefined;
    }
  }

  /**
   * reset filters selection
   */
  setDefaultFilters() {
    // this.suggestedLineItems = [];
    // this.tickers = [];
    // this.lineItem = [];
    // this.selectedLineItemId = [];
    // this.viewBy = [];
    // this.revision = "";
    // this.currency = "";
    // this.periodData = undefined;
    // this.periodUserSetting = undefined;
    // this.showBlankRows = false;
    // this.hasShowMoreButton = false;
    // this.showBlankRowsLabel = "Show Blank Rows";
    // this.source = undefined;
  }

  checkIfUserPageType() {
    return this.pageType === "user";
  }

  /**
   * Set the snackbar message and snackbarRef
   */
  showSnackBarToastMessage(info, duration = 5000) {
    this.snackbarMessage = info.message;
    this.snackBarRef = this.getSnackbarRef(info.type, duration);
  }

  /**
   * Hides the snack bar
   */
  dismissSnackBar() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
      this.overlayOn = false;
    }
  }

  /**
   * Shows snackbar message, according to (success | info | failure) template
   * @param {object} type - type of message (success | info | failure)
   */
  getSnackbarRef(type, duration = 5000) {
    const typeMap = {
      success: this.successTemplate,
      info: this.infoTemplate,
      failure: this.failureTemplate,
      warning: this.warningTemplate,
    };
    if (typeMap[type]) {
      if (type === "warning") {
        this.overlayOn = true;
      }
      return this.snackBar.openFromTemplate(typeMap[type], {
        panelClass: type,
        duration: duration,
        verticalPosition: "top",
      });
    }
    return undefined;
  }

  /**
   * Returns array of tickers id from array of tickers object.
   * @returns {array} - array of ticker id
   */
  getTickerIdArray() {
    return this.compsTableData && this.compsTableData.rows
      ? this.compsTableData.rows.map((item) => item.ticker)
      : [];
  }

  /**
   * It stores the selected line item
   * It makes data call request and updates grid data
   * @param {obect} item - selected line item
   */
  updateLineItem(item) {
    const id = item.uniquesliid || item.sli_id;
    this.updateFormattedLineItem(
      this.lineItem.concat(item),
      this.selectedLineItemId.concat(id),
    );
    this.snackbarInfo.message = `${item.label} Line Item selected.`;
    this.snackbarInfo.type = "success";
    this.showSnackBarToastMessage(this.snackbarInfo);
  }

  updateMultipleLineItem(item, marketData) {
    const lineitemId = [];
    const lineItems = [];
    for (const li of item) {
      lineItems.push(li);
      lineitemId.push(li.uniquesliid || li.sli_id);
    }
    this.updateFormattedLineItem(lineItems, lineitemId, marketData);
  }

  /**
   * Executes on the selection of lineitem
   * It checks if lineitem exists or not and shows toast message according to it.
   * It formats the line item, and removes unnecessary items
   * It updates the line item
   * @param {object} item - selected lineitem
   */
  handleLineItemSelection(item) {
    if (item && this.lineItem.length < this.MAX_LINES_TIMESERIES) {
      const formatLineItem = { ...item, parent: undefined }; // remove the parent property from selected lineitem
      const isUserPageType = this.checkIfUserPageType();
      if (isUserPageType) {
        this.isUserSettingUpdateInProgress = true;
        const lineItemToUpdate = {
          LineItem: {
            line_ids: this.selectedLineItemId.concat(
              formatLineItem.uniquesliid,
            ),
          },
        };
        const settingsPayload = updateCustomTableSettings(
          this.compId,
          TAB_BE_MAPPING.comparison,
          lineItemToUpdate,
        );
        this.dataService
          .updateCustomComps(settingsPayload)
          .subscribe((response) => {
            if (response.status === "success") {
              this.updateLineItem(formatLineItem);
            }
            this.isUserSettingUpdateInProgress = false;
          });
      } else {
        this.updateLineItem(formatLineItem);
        this.updateUnsavedDataStatus.emit();
      }
    } else {
      this.snackbarInfo.message = `Line item can not be added. You have reached the line item limit.`;
      this.snackbarInfo.type = "warning";
      this.showSnackBarToastMessage(this.snackbarInfo, null);
    }
  }

  handleMultipleLineItemSelection(item, marketData) {
    if (item) {
      const lineItems = [...item]; // remove the parent property from selected lineitem
      const isUserPageType = this.checkIfUserPageType();
      if (isUserPageType) {
        this.isUserSettingUpdateInProgress = true;
        const lineItemToUpdate = {
          LineItem: {
            line_ids: lineItems.map((item) => item.uniquesliid),
          },
        };
        if (marketData && marketData.length) {
          lineItemToUpdate.LineItem["market_data"] =
            getSelectedMarketIdFromList(marketData);
        }
        const settingsPayload = updateCustomTableSettings(
          this.compId,
          TAB_BE_MAPPING.comparison,
          lineItemToUpdate,
        );
        this.dataService
          .updateCustomComps(settingsPayload)
          .subscribe((response) => {
            if (response.status === "success") {
              this.updateMultipleLineItem(lineItems, marketData);
            }
            this.isUserSettingUpdateInProgress = false;
          });
      } else {
        this.updateMultipleLineItem(lineItems, marketData);
        this.updateUnsavedDataStatus.emit();
      }
    }
  }

  /**
   * Executes on selection of currency
   * It stores currency
   * @param {object} item - selected currency
   */
  handleCurrencyChange(item) {
    if (!item) {
      return;
    }

    const isUserPageType = this.checkIfUserPageType();

    this.currency = item;

    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const currencyToUpdate = {
        Currency: {
          currency_iso: item,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        TAB_BE_MAPPING.comparison,
        currencyToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.currencyMessageSubscriber = this.compsDataService
              .getCurrencyMessage(item)
              .subscribe((res) => {
                if (res["status"] === "success") {
                  this.updateCompState.emit({
                    currency: item,
                    magnitudeMessage: res["magnitude_message"],
                  });
                }
              });
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.currencyMessageSubscriber = this.compsDataService
        .getCurrencyMessage(item)
        .subscribe((res) => {
          if (res["status"] === "success") {
            this.updateCompState.emit({
              currency: item,
              magnitudeMessage: res["magnitude_message"],
            });
          }
        });
      this.updateUnsavedDataStatus.emit();
    }
  }

  /**
   * Executes on period selection
   * It updates the selected period data to tab state
   *@param {{updatedPeriodData: ValuationPeriodState, periodUserSettingData: PeriodUserSettingObj}} periodData: selected values from period filter popup
   */
  handlePeriodSelection(periodData) {
    const { updatedPeriodData, periodUserSettingData } = periodData;
    const periodList = getSelectedPeriods(
      updatedPeriodData,
      false,
      false,
      true,
    );
    const periodTypeId = periodUserSettingData.type;
    const selectedBasisId =
      updatedPeriodData &&
      updatedPeriodData.period_basis &&
      updatedPeriodData.period_basis[periodTypeId]
        ? getSelectedBasisOptionId(
            updatedPeriodData.period_basis[periodTypeId].from_basis,
          )
        : undefined;
    const isYearlyBasisId = isBasisFullYear(selectedBasisId);
    const periodLabel =
      periodTypeId === "rel"
        ? periodList.map((item) =>
            convertRelativePeriodIdToLabel(item, isYearlyBasisId),
          )
        : periodList;

    this.updateCompState.emit({
      periodData: updatedPeriodData,
      periodList: periodList,
      periodLabel: periodLabel,
      periodUserSetting: periodUserSettingData,
      periodType: periodTypeId,
    });
  }

  /**
   * Executes on click of Period filter popup's Apply button.
   * It posts the selected period setting to user setting api
   * It updates periodData and periodSettings
   * @param {{updatedPeriodData: ValuationPeriodState, periodUserSettingData: PeriodUserSettingObj}} periodData: selected values from period filter popup
   */
  handlePeriodApply(periodData: {
    updatedPeriodData: PeriodState;
    periodUserSettingData: PeriodUserSettingObj;
  }) {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const periodToUpdate = {
        Period: periodData.periodUserSettingData,
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        TAB_BE_MAPPING.comparison,
        periodToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.handlePeriodSelection(periodData);
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.handlePeriodSelection(periodData);
      this.updateUnsavedDataStatus.emit();
    }
  }

  /**
   * Executes on growth/revision change
   * It Updates `viewBy` and `revision`.
   * @param {{viewBy: Array, revision: string}} item - selected growth revision
   */
  updateGrowthRevision(item) {
    if (item) {
      const isUserPageType = this.checkIfUserPageType();
      if (isUserPageType) {
        this.isUserSettingUpdateInProgress = true;
        const dataviewToUpdate = {
          DataView: {
            view_by: item.viewBy,
            revision: item.revision,
          },
        };
        const settingsPayload = updateCustomTableSettings(
          this.compId,
          TAB_BE_MAPPING.comparison,
          dataviewToUpdate,
        );
        this.dataService
          .updateCustomComps(settingsPayload)
          .subscribe((response) => {
            if (response.status === "success") {
              this.updateCompState.emit({
                viewBy: item.viewBy,
                revision: item.revision,
              });
            }
            this.isUserSettingUpdateInProgress = false;
          });
      } else {
        this.updateCompState.emit({
          viewBy: item.viewBy,
          revision: item.revision,
        });
        this.updateUnsavedDataStatus.emit();
      }
    }
  }

  /**
   * Executes on remove blanks switch change
   * It stores the value to user settings
   * @param {boolean} value - selected value of remove blank
   */
  handleShowBlanksSwitchChange(value) {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const showBlankToUpdate = {
        ShowBlank: {
          show_blank: value,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        TAB_BE_MAPPING.comparison,
        showBlankToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.updateTrendStateWithoutMakingDataCalls.emit({
              showBlankRows: value,
            });
            this.showBlankRows = value;
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.updateTrendStateWithoutMakingDataCalls.emit({
        showBlankRows: value,
      });
      this.showBlankRows = value;
      this.updateUnsavedDataStatus.emit();
    }
  }

  handleTickerOrderUpdate(tickerOrderedList) {
    this.sortedTickers = tickerOrderedList;
  }

  /**
   * Returns the tabId which can be used to pass it to export call
   * Since the current comp table doesn't has tabid, we generate it by making post call to saveNewComp
   * @returns {number} - tabId
   */
  getTabIdForExport() {
    const compName = this.headerTitle;
    const tickerInfo = this.sortedTickers;
    const lineItemInfoArray = this.getLineItemInfoforExport();
    const tabType = CompTypes.normalcomp;
    const periodSettings = this.periodUserSetting;
    const yearType = "Calendarized";
    const currency = this.currency;
    const viewBy = this.viewBy;
    const revision = this.revision;
    const additionalColumns = this.marketItemsData
      .filter((data) => data.checked)
      .map((data) => data.id);

    let dataView = {};
    if (viewBy) {
      dataView = { view_by: viewBy };
    }
    if (revision !== "") {
      dataView = { view_by: viewBy, revision: revision };
    }
    return this.compsDataService.saveNewComp(
      compName,
      tickerInfo,
      lineItemInfoArray,
      tabType,
      periodSettings,
      yearType,
      currency,
      dataView,
      false,
      additionalColumns,
    );
  }

  /**
   * Returns the formatted line item
   * @returns {object} - Lineitem
   */
  getLineItemInfoforExport() {
    if (!this.lineItem) {
      return undefined;
    }
    const lineItemList = this.lineItem.map((lineItem) => {
      return {
        fuzzysli: 0,
        name: lineItem.name,
        period: this.periodList,
        sli_comps_id: 0,
        sli_id: lineItem.uniquesliid,
        source: this.source,
      };
    });
    return lineItemList;
  }

  getPeriodsWithAvailableData(tickerIds) {
    this.appService
      .getPeriodsWithData(tickerIds)
      .subscribe((response: { status; dataAvailable }) => {
        if (response.status === "success") {
          this.periodsWithAvailableData = response.dataAvailable;
        }
      });
  }

  onSourceChange(item) {
    if (item) {
      const isUserPageType = this.checkIfUserPageType();
      if (isUserPageType) {
        this.isUserSettingUpdateInProgress = true;
        const sourceToUpdate = {
          Source: {
            source_name: item,
          },
        };
        const settingsPayload = updateCustomTableSettings(
          this.compId,
          TAB_BE_MAPPING.comparison,
          sourceToUpdate,
        );
        this.dataService
          .updateCustomComps(settingsPayload)
          .subscribe((response) => {
            if (response.status === "success") {
              this.updateCompState.emit({ source: item });
            }
            this.isUserSettingUpdateInProgress = false;
          });
      } else {
        this.updateCompState.emit({ source: item });
        this.updateUnsavedDataStatus.emit();
      }
    }
  }

  OnCompsDataCallInPogressChange(value) {
    this.isCompsDataInProgress = value;
  }

  updateEditLineItems(data, marketItemsData) {
    this.handleMultipleLineItemSelection(data, marketItemsData);

    this.destroyModal();
  }

  handleEditLineItems() {
    this.lineItemsModal = this.modalService.create({
      nzTitle: this.modalTitle,
      nzOkLoading: true,
      nzContent: LineItemModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addColTableData: this.lineItem,
        stdLineItems: this.lineItemsData,
        max: this.MAX_LINES_TIMESERIES,
        maxHeight: "290px",
        tickers: this.tickers,
        createSource:
          this.source === "VA Actuals/Consensus"
            ? "vaactuals.consensus"
            : this.source,
        marketItemsData: [...this.marketItemsData],
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            // reset market items to last state
            this.marketItemsData = this.marketItemsData.map((item) => ({
              ...item,
              checked: this.marketDataItemCopy.includes(item.id),
            }));
            this.lineItemsModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          nzClassName: (data) => {
            return data.modalData.length > data.max ? "disable" : "";
          },
          onClick: (data): void => {
            this.updateEditLineItems(data.modalData, data.marketItemsData);
            // if(this.updated)
            // this.lineItemsModal.destroy();
          },
          disabled: (data) => {
            // let disable = data.modalData.length > 50 ? true : false;
            // if(disable){
            //   document.getElementsByClassName("update-btn")? document.getElementsByClassName("update-btn")[0].setAttribute("nz-tooltip", ""):'';
            //   document.getElementsByClassName("update-btn")? document.getElementsByClassName("update-btn")[0].setAttribute("nzTooltipTitle", "exceeded"):'';
            // }
            return (
              data.modalData.length > data.max || data.modalData.length === 0
            );
          },
        },
      ],
      nzOnCancel: () => {
        // reset market items to last state
        this.marketItemsData = this.marketItemsData.map((item) => ({
          ...item,
          checked: this.marketDataItemCopy.includes(item.id),
        }));
      },
    });
    this.dismissSnackBar();
  }

  destroyModal(): void {
    this.lineItemsModal.destroy();
  }

  downloadComps(params) {
    this.loadingDocuments = true;
    params = `${params}&apply_yoy_format=${this.apply_yoy_format}`;
    const useNewAPI = true;
    this.compsDataService.exportComparativeComps(params, useNewAPI).subscribe(
      (res) => {
        if (res["status"] === "success") {
          const fileName = res["filename"];
          const trackerId = res["trackerid"];
          const downloadUrl = `/api/excel_file_download?exceltrackerid=${trackerId}`;
          const startIFrameTime = new Date().getTime();
          const iFrameToLoad = this._document.createElement("iframe");
          const body = this._document.getElementsByTagName("body")[0];
          iFrameToLoad.id = `${fileName}`;
          iFrameToLoad.name = `${fileName}`;
          iFrameToLoad.src = downloadUrl;
          iFrameToLoad.setAttribute("style", "visibility:hidden;display:none");
          body.appendChild(iFrameToLoad);

          const checkInterval = setInterval(() => {
            const iFrameToGet = this._document.getElementById(
              `${fileName}`,
            ) as HTMLIFrameElement;
            const iFrame =
              iFrameToGet.contentDocument || iFrameToGet.contentWindow.document;
            /*
            This check will run till the iFrame either doesn't load or for a max of 30secs
            Or till the ready state of the iFrame doesn't evaluate
          */
            if (
              iFrame.readyState === "complete" ||
              iFrame.readyState === "interactive" ||
              new Date().getTime() - startIFrameTime > 30000
            ) {
              //Commenting for now
              // this._document
              //   .getElementById(`research_download_${dataToPass.id}`)
              //   .remove();
              clearInterval(checkInterval);
              return;
            }
          }, 2000);
          this.loadingDocuments = false;
          // iframe.onload = () => {
          //   setTimeout(function() {
          //     document.getElementById(`research_download_${dataToPass.id}`).remove();
          //   }, 100);
          //   this.loading = false;
          // };
        } else {
          this.loadingDocuments = false;
          this.snackbarInfo.message = `Export couldn't be downloaded.`;
          this.snackbarInfo.type = "failure";
          this.showSnackBarToastMessage(this.snackbarInfo);
        }
      },
      (err) => {
        this.loadingDocuments = false;
        console.error(err);
      },
    );
  }

  exportValue(exportType: number) {
    this.exportOptVisible = false;
    if (exportType === 0 && this.source.toLowerCase() === "consensus+") {
      this.snackbarInfo.message = `Add-in formulas are not available for Consensus+ at this time.`;
      this.snackbarInfo.type = "info";
      this.showSnackBarToastMessage(this.snackbarInfo);
    } else {
      this.getTabIdForExport().subscribe((res) => {
        if (res["status"] === "success") {
          if (exportType === 0) {
            //Allow values or yoy for excel version export
            if (
              this.viewBy.length === 1 &&
              (this.viewBy.includes("values") || this.viewBy.includes("yoy"))
            ) {
              let params = `tabid=${res["tab_id"]}&comps_type=${this.selectedCompsType}&export_type=${exportType}&viewBy=${this.viewBy[0]}`;
              if (this.currency !== "Base") {
                params = `${params}&currency=${this.currency}`;
              }
              this.downloadComps(params);
            } else {
              //Allow values and yoy for excel version export
              if (
                this.viewBy.length === 2 &&
                this.viewBy.includes("values") &&
                this.viewBy.includes("yoy")
              ) {
                let params = `tabid=${res["tab_id"]}&comps_type=${this.selectedCompsType}&export_type=${exportType}&viewBy=${this.viewBy[0]}&viewBy=${this.viewBy[1]}`;
                if (this.currency !== "Base") {
                  params = `${params}&currency=${this.currency}`;
                }
                this.downloadComps(params);
              } else {
                this.snackbarInfo.message = `Excel export is not yet available. We will be adding this feature very soon.`;
                this.snackbarInfo.type = "failure";
                this.showSnackBarToastMessage(this.snackbarInfo);
              }
            }
          } else {
            //Export Value version
            if (this.viewBy.length < 2) {
              let params = `tabid=${res["tab_id"]}&comps_type=${this.selectedCompsType}&export_type=${exportType}`;
              //Export Revision for values
              if (this.viewBy.length && this.viewBy.includes("revision")) {
                params += `&viewBy=revision`;
                if (this.revision && this.revision !== "") {
                  params += `&revision=${this.revision}`;
                }
              } else {
                //export value or yoy for values
                params += `&viewBy=${this.viewBy[0]}`;
              }
              if (this.currency !== "Base") {
                params = `${params}&currency=${this.currency}`;
              }
              this.downloadComps(params);
            } else {
              //Allow values and yoy for value version export
              if (
                this.viewBy.length === 2 &&
                this.viewBy.includes("values") &&
                this.viewBy.includes("yoy")
              ) {
                let params = `tabid=${res["tab_id"]}&comps_type=${this.selectedCompsType}&export_type=${exportType}&viewBy=${this.viewBy[0]}&viewBy=${this.viewBy[1]}`;
                if (this.currency !== "Base") {
                  params = `${params}&currency=${this.currency}`;
                }
                this.downloadComps(params);
                // this.message.create(
                //   "error",
                //   `Excel export for combined Values/YoY tables are not yet available. We will be adding this feature soon.`
                // );
              } else {
                this.snackbarInfo.message = `Excel export is not yet available. We will be adding this feature very soon.`;
                this.snackbarInfo.type = "failure";
                this.showSnackBarToastMessage(this.snackbarInfo);
              }
            }
          }
        } else {
          console.error("Could not generate tab id");
          this.snackbarInfo.message = `Something went wrong`;
          this.snackbarInfo.type = "failure";
          this.showSnackBarToastMessage(this.snackbarInfo);
        }
      });
    }
  }

  editTickers() {
    this.tickersModal = this.modalService.create({
      nzTitle: "Edit Tickers",
      nzContent: ComparativeTickerModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addRowTableData: this.tickers, //this.addRowTableData,
        suggestedPeers: {
          watchername: "Suggested Peers",
          company_info: this.suggestedPeers,
        },
        recentlyVisitedCompanies: {
          company_info: this.recentlyVisitedCompanies
            ? [...this.recentlyVisitedCompanies]
            : [],
          watchername: "Recently viewed (up to 30)",
        },
        industryData: this.industryMenuData ? [...this.industryMenuData] : [],
        watchlistData: this.watchlistData ? [...this.watchlistData] : [],
        watchlistName: this.headerTitle,
        marketGeoData: this.marketGeoData
          ? { ...this.marketGeoData }
          : undefined,
        maxHeight: "340px",
        mpt: 1, //this.mpt,
        type: "edit",
        maxTickers: this.tickerLimit,
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      // nzWrapClassName: "watchlist-modal-container search-and-add-modal-container",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.tickersModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          onClick: (data): void => {
            this.updateTickers(data);
          },
          disabled: (data) => {
            return (
              data["watchlistError"] !== "" ||
              data["modalData"].length > this.tickerLimit ||
              data["modalData"].length === 0
            );
          },
        },
      ],
    });
  }

  saveWatchlist(watchistError, modalData, watchlistName) {
    const tickerList = modalData.map((item) => {
      return item.ticker;
    });
    if (
      watchistError === "" &&
      watchlistName &&
      watchlistName.length > 0 &&
      tickerList.length > 0
    ) {
      const jsonData = {
        watchername: watchlistName,
        tickerlist: tickerList,
      };
      // this.isLoadingSaveWatchlist = true;
      let watchlistId = "";
      this.watchlistDataService.saveWatchlist(jsonData).subscribe(
        (response) => {
          if (response.status === "success") {
            watchlistId = response.watchlistid.toString();
            this.addWatchlistStore(watchlistId, watchlistName);
            this.initiateWatchlistFetch.emit();
          }
          this.snackbarInfo.message = `${watchlistName} saved as a new watchlist`;
          this.snackbarInfo.type = "info";
          this.showSnackBarToastMessage(this.snackbarInfo);
        },
        (error) => {
          // this.isLoadingSaveWatchlist = false;
          console.error(error);
        },
      );
    }
  }

  addWatchlistStore(watchlistId, watchlistName) {
    const payload = {
      respData: {
        watchlistId: Number(watchlistId),
        label: watchlistName,
      },
      key: this.storeDataKey,
    };
    this.store.dispatch(new AddWatchlistData(payload));
  }

  updateTickers(data) {
    const { modalData, watchlistName, watchlistError } = data;
    this.tickersModal.destroy();
    // FOR SAVING WATCHLIST
    if (data.saveWatchlist) {
      this.saveWatchlist(watchlistError, modalData, watchlistName);
    }
    const tickerId = [];
    const companyId = [];
    for (const item of modalData) {
      tickerId.push(item.ticker);
      companyId.push(item.company_id || item.cid);
    }
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const tickerToUpdate = {
        Ticker: {
          cids: companyId,
        },
      };
      const settingsPayload = updateCustomTableSettingsForTickers(
        this.compId,
        TAB_BE_MAPPING.comparison,
        tickerToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.updateCompState.emit({ tickers: modalData });
            this.onFetchLineitemData.emit({
              tickers: tickerId,
              showSuggestedLineItems: true,
              currency: this.currency,
            });
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.updateCompState.emit({ tickers: modalData });
      this.updateGridSortByColumnId.emit();
      this.updateUnsavedDataStatus.emit();
      this.onFetchLineitemData.emit({
        tickers: tickerId,
        showSuggestedLineItems: true,
        currency: this.currency,
      });
    }
  }

  onSearchTickerSelection(tickerData) {
    const { value } = tickerData;
    let checIfTickerExist = false;
    for (const item of this.tickers) {
      if (item.ticker === value.ticker) {
        checIfTickerExist = true;
        this.snackbarMessage = "This ticker is already present.";
        this.snackBarRef = this.snackBar.openFromTemplate(this.infoTemplate, {
          panelClass: "info",
          duration: 5000,
          verticalPosition: "top",
        });
      }
    }
    if (!checIfTickerExist && this.tickers.length <= this.tickerLimit) {
      this.updateSearchedTicker(tickerData);
    }
  }

  updateSearchedTicker(selectedTicker) {
    const tickerObj = {
      full_name: selectedTicker.value.name || selectedTicker.value.full_name,
      name: selectedTicker.value.name || selectedTicker.value.full_name,
      ticker: selectedTicker.value.ticker,
      company_id: selectedTicker.value.cid,
    };
    const allTickers = this.tickers.concat(tickerObj);
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const tickerToUpdate = {
        Ticker: {
          cids: allTickers.map(
            (item) => item.company_id || item.cid || item.companyid,
          ),
        },
      };
      const settingsPayload = updateCustomTableSettingsForTickers(
        this.compId,
        TAB_BE_MAPPING.comparison,
        tickerToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.updateCompState.emit({ tickers: allTickers });
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.updateCompState.emit({ tickers: allTickers });
      this.updateGridSortByColumnId.emit();
      this.updateUnsavedDataStatus.emit();
    }
    this.snackbarInfo.message = `${selectedTicker.value.ticker} has been added to the Table.`;
    this.snackbarInfo.type = "success";
    this.showSnackBarToastMessage(this.snackbarInfo);
  }

  updateFormattedLineItem(lineItem, lineitemId, marketData?) {
    const sliId =
      lineitemId ||
      this.lineItem.map((item) => {
        return item.uniquesliid;
      });
    this.dataService
      .getLineItemDetails(
        sliId,
        this.industryId,
        this.currency,
        this.tickers[0].ticker,
      )
      .subscribe((response) => {
        if (response.status === "success" && response.data) {
          lineItem.forEach((item) => {
            item["formatted_name"] = response.data[item.uniquesliid]
              ? response.data[item.uniquesliid]["formatted_name"]
              : item.name;
            item["totaled"] = response.data[item.uniquesliid]
              ? response.data[item.uniquesliid]["totaled"]
              : false;
            item["addin_name"] = response.data[item.uniquesliid]
              ? response.data[item.uniquesliid]["addin_name"]
              : item.name;
          });
        }

        const dataToUpdate = {
          lineItem: lineItem,
          selectedLineItemId: lineitemId,
        };
        if (marketData) {
          dataToUpdate["marketItemsData"] = marketData;
        }
        this.updateCompState.emit(dataToUpdate);
      });
  }

  handleCollpsibleChange({ item, i }) {
    const isOpen = item.isOpen;
    if (!isOpen) {
      this.collapsibleList[i].isOpen = !isOpen;
      this.activeAccordionItemId = item.id;
    }
  }

  createNewCollapsibleList(periodList, periodLabel) {
    const activeAccordionItemIdExist = this.activeAccordionItemId;
    const activeAccodionExist =
      activeAccordionItemIdExist &&
      periodList.includes(this.activeAccordionItemId);
    return periodList.map((item, i) => {
      if ((!activeAccordionItemIdExist || !activeAccodionExist) && i === 0) {
        this.activeAccordionItemId = item;
      }
      return {
        id: item,
        label: periodLabel[i] || item,
        isOpen: this.activeAccordionItemId === item,
      };
    });
  }

  showChartPopup(chartData: Dictionary<any>) {
    const sourcesToShow = this.sourceList.filter(
      (s) =>
        !s.toLowerCase().includes("va actuals") &&
        s.toLowerCase() !== "filings" &&
        s.toLowerCase() !== "consensus+",
    );
    const hasOtherPeriod = ["NTM", "LTM", "STM"].includes(
      chartData.item.period,
    );
    this.chartPopupDataToUse = {
      companyFullName: chartData.item.row.full_name,
      period: !hasOtherPeriod ? chartData.item.period : "",
      periodType: getPeriodTypeDataId(this.periodData),
      otherPeriod: hasOtherPeriod ? chartData.item.period : "",
      // source: this.source,
      sourceList: sourcesToShow.map((source) => {
        return {
          label: source,
          value: source,
          checked: source === this.source || source === "Consensus",
        };
      }),
      forecast: !chartData.item.showSurprise,
      cut: "STD",
      isPeers: false,
      gAdjust: "implied",
      dapparamId: chartData.item.dapParamId,
      ticker: chartData.item.row.ticker,
      export: true,
      selectedCurrency: this.currency,
      basisType: getSelectedPeriodBasis(this.periodData.basis),
      calendarization: true,
      isValuationRatio: chartData.item.isValuationRatio,
      is_comparative: true,
    };
    if (this.source !== "VA Actuals/Consensus") {
      this.chartPopupDataToUse["source"] = this.source;
    } else {
      if (this.chartPopupDataToUse.forecast) {
        this.chartPopupDataToUse["source"] = "Consensus";
      } else {
        this.chartPopupDataToUse["source"] = "VA Actuals";
      }
    }
    this.chartPopupType = chartData.chartType;
    this.chartPopupVisible = true;
  }

  hideChartPopup() {
    this.chartPopupVisible = false;
    this.chartPopupType = "";
  }
}
